import { render, staticRenderFns } from "./side-rail.vue?vue&type=template&id=16144496&scoped=true"
import script from "./side-rail.vue?vue&type=script&lang=js"
export * from "./side-rail.vue?vue&type=script&lang=js"
import style0 from "./side-rail.vue?vue&type=style&index=0&id=16144496&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16144496",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16144496')) {
      api.createRecord('16144496', component.options)
    } else {
      api.reload('16144496', component.options)
    }
    module.hot.accept("./side-rail.vue?vue&type=template&id=16144496&scoped=true", function () {
      api.rerender('16144496', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/desktop/side-rail.vue"
export default component.exports